import AttendanceSetting from "./attendanceSetting";
export default AttendanceSetting;